export default "__VITE_ASSET__RSyp3uIy__"